import { graphql } from "../generated";

export const LanguagesDocument = graphql(`
  query Languages {
    languages {
      name
      code
    }
  }
`);
